const alertTextMap = {
  'New report ready': 'A report you’ve generated is ready to view',
  'Reset your password': 'Knotch profile needs new password',
  'blueprint monthly reports': "We'll notify you when a monthly report is ready to view.",
  'blueprint weekly reports': "We'll notify you when a weekly report is ready to view.",
};

export default alertTextMap;
